export default __webpack_public_path__ + "static/webRotator/svg/c92f004ef7ede061076d7535e7831190.svg";